export default __webpack_public_path__ + "static/media/img-slider-siamblockchain-7.aa17d4a7.png";